import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomDot = createSvgIcon(<path d="M15 12c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3" />, 'CustomDot');

export default CustomDot;
